import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { RegionsProvider as Provider } from '../../components/context/regions.context';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllRegionsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Regions" } }) {
    nodes {
      data
    }
  }
}
`;

export const RegionsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};
